// externals
import { StyleSheetManager as ScStyleSheetManager, ThemeProvider } from 'styled-components';

// libraries
import type { Dealer } from '@makemydeal/dr-shared-types';
import type { FeatureTogglesAndUrlOnly } from '@makemydeal/dr-shared-store';
import { SALES_CHECKIN_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { DDJPreloader } from '@makemydeal/dr-activities-ddj';
import { SalesCheckinGlobalSpinner } from '@makemydeal/dr-activities-sales-checkin';
import { BridgeBarHeader, SessionExpiredOverlay, useAppTheme } from '@makemydeal/dr-sales-checkin-components';

// components
import { GlobalStyle } from '../../../globalStyle/GlobalStyle.style';
import { BodyContainer } from './BodyContainer';
import GlobalErrorHandler from '../errorHandler/GlobalErrorHandler';
import GlobalRouter from './GlobalRouter';
import { ViewAsBanner } from '@makemydeal/dr-activities-role-assumption';
import RoleAssumptionWrapper from './RoleAssumptionWrapper';

export type RoutesProps = {
    toggles: FeatureTogglesAndUrlOnly;
    dealer: Partial<Dealer>;
};

const StyleSheetManager = ScStyleSheetManager as any;

export const Routes: React.FC<RoutesProps> = () => {
    const theme = useAppTheme();

    if (!theme) {
        return null;
    }

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <StyleSheetManager disableCSSOMInjection>
                <>
                    <BridgeBarHeader appPrefix={SALES_CHECKIN_APP_PREFIX} />
                    <GlobalErrorHandler />
                    <SessionExpiredOverlay />
                    <SalesCheckinGlobalSpinner />
                    <DDJPreloader />

                    <BodyContainer>
                        <RoleAssumptionWrapper>
                            <ViewAsBanner />
                            <GlobalRouter />
                        </RoleAssumptionWrapper>
                    </BodyContainer>
                </>
            </StyleSheetManager>
        </ThemeProvider>
    );
};
